<template>
  <v-container class="col-12">
    <v-card class="pa-4">
      <v-row class="mx-0">
        <select-project
          v-model="project"
          class="col-1"
          style="min-width: 250px; max-width: 250px"
        ></select-project>

        <date-picker
          v-model="from"
          label="Date From"
          style="max-width: 140px"
        />

        <date-picker
          v-model="to"
          label="Date To"
          style="max-width: 140px"
        />

        <v-btn color="info" v-on:click="search" class="mt-3" :disabled="loading" :loading="loading">Search</v-btn>
      </v-row>
    </v-card>


    <v-card class="pa-0 mt-4">
      <v-select
        v-if="!loading"
        :value="selectedColumns"
        @input="(columns) => setSelectedColumns(columns, 'deposit')"
        :items="headers.filter(({text}) => !!text)"
        prepend-inner-icon="mdi-menu"
        append-icon=""
        hide-details
        multiple
        persistent-placeholder
        class="data-table__select-row mr-5"
        style="width: 0"
      >
        <template v-slot:selection="{ item, index }" />
      </v-select>
      <v-data-table
        :loading="loading"
        :server-items-length="total"
        :headers="selectedHeaders(headers)"
        :options.sync="options"
        :items="items"
        :expanded.sync="expanded"
        sort-by="created"
        sort-desc
        item-key="account_transaction_id"
        :footer-props="{'items-per-page-options': [15, 25, 50, 100]}"
        :items-per-page="15"
        :class="{'payment-handler-dt': true, 'footer-padding': $store.state.auth.checkAccess({key: 'kiosk.access', value: true})}"
        show-expand
        style="z-index: 0; position: relative;"
      >
        <template v-slot:body.prepend>
          <tr class="grey lighten-3">
            <td
              v-for="header in selectedHeaders(headers)"
              :key="header.text"
            >
              <v-select
                v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'select'"
                hide-details
                dense
                small
                multiple
                clearable
                persistent-hint
                return-object
                single-line
                class="data-table-finance-filter-select"
                :items="getSelectFilterValue(header.value)"
                v-model="filters[header.value].data"
              />
              <v-text-field
                class="data-table-finance-filter-textfield"
                v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'text'"
                v-model="filters[header.value].data"
                hide-details
              />
            </td>
          </tr>
        </template>

        <template v-slot:expanded-item="{ headers , item }">
          <td :colspan="headers.length">
            <v-row class="col-12 px-5 pb-0 payment-handler-details">

              <v-text-field
                :value="item.account_transaction_id"
                label="ID"
                small
                outlined
                readonly
                hide-details
                class="col-2 "
              ></v-text-field>
              <v-text-field
                :value="item.login"
                label="Login"
                small
                outlined
                readonly
                hide-details
                class="col-2 "
              ></v-text-field>
              <v-text-field
                :value="item.type"
                label="Type"
                small
                outlined
                readonly
                hide-details
                class="col-2 "
              ></v-text-field>
              <v-text-field
                :value="item.status"
                label="Status"
                small
                outlined
                readonly
                hide-details
                class="col-2 "
              ></v-text-field>
              <v-text-field
                :value="item.amount"
                :label="`Amount (${item.currency})`"
                :suffix="item.currency"
                small
                outlined
                readonly
                hide-details
                class="col-2  text-right"
              ></v-text-field>
              <v-text-field
                :value="item.amount_eur"
                label="Amount (EUR)"
                suffix="EUR"
                small
                outlined
                readonly
                hide-details
                class="col-2  text-right"
              ></v-text-field>
              <v-text-field
                :value="item.account"
                label="Account"
                small
                outlined
                readonly
                hide-details
                class="col-2 "
              ></v-text-field>
              <v-text-field
                :value="item.paymethod"
                label="Paymethod"
                small
                outlined
                readonly
                hide-details
                class="col-2 "
              ></v-text-field>
              <v-text-field
                :value="item.paysystem"
                label="Paysystem"
                small
                outlined
                readonly
                hide-details
                class="col-2 "
              ></v-text-field>
              <v-text-field
                :value="item.email"
                label="Email"
                small
                outlined
                readonly
                hide-details
                class="col-2 "
              ></v-text-field>
              <v-text-field
                :value="item.phone"
                label="Phone"
                small
                outlined
                readonly
                hide-details
                class="col-2 "
              ></v-text-field>
              <v-text-field
                :value="item.created"
                label="Created"
                small
                outlined
                readonly
                hide-details
                class="col-2 "
              ></v-text-field>
              <v-text-field
                :value="item.updated"
                label="Updated"
                small
                outlined
                readonly
                hide-details
                class="col-2 "
              ></v-text-field>
              <v-text-field
                :value="item.name"
                label="Name"
                small
                outlined
                readonly
                hide-details
                class="col-2 "
              ></v-text-field>
              <v-text-field
                :value="item.surname"
                label="Surname"
                small
                outlined
                readonly
                hide-details
                class="col-2 "
              ></v-text-field>
            </v-row>

            <v-row class="col-12 px-5 pt-0 payment-handler-details">

              <v-text-field
                v-for="(param, key) in (item.details.params || {})"
                :key="key"
                :value="param"
                :label="startCase(key)"
                small
                outlined
                readonly
                hide-details
                class="col-2 "
              ></v-text-field>


              <v-textarea
                :value="item.comment"
                label="Comment"
                small
                outlined
                auto-grow
                rows="1"
                readonly
                hide-details
                class="col-12 no-resize"
              ></v-textarea>
            </v-row>

          </td>
        </template>


        <template v-slot:item.login="{ item, header }">
          <a :href="'/user-management/' + item.login " target="_blank">{{ item.login }}</a>
        </template>
        <template v-slot:item.account_id="{ item, header }">
          <a :href="'/user-management/' + item.login " target="_blank">{{ item.account_id }}</a>
        </template>


        <template v-slot:item.status="{ item }">
          <v-select
            :items="statuses"
            v-model="item.status"
            :readonly="!$store.state.auth.checkAccess({key: 'payment_handler_update', value: true})"
            dense
            hide-details
            small
            style="max-width: 150px;"
          ></v-select>
        </template>
        <template v-slot:item.comment="{ item }">
          <div style="min-width: 250px;">
            <v-textarea
              placeholder="Comment"
              v-model="item.comment"
              small
              auto-grow
              rows="1"
              hide-details
              :readonly="!$store.state.auth.checkAccess({key: 'payment_handler_update', value: true})"
              :append-icon="$store.state.auth.checkAccess({key: 'payment_handler_update', value: true}) ? 'mdi-content-save' : ''"
              @click:append="updateTransaction(item)"
              class="col-12 payment-handler-update-comment pa-0 ma-0"
            ></v-textarea>
          </div>
        </template>
        <template v-slot:item.created="{ item }">
          <div style="min-width: 150px;">
            {{ item.created }}
          </div>
        </template>
        <template v-slot:item.updated="{ item }">
          <div style="min-width: 150px;">
            {{ item.updated }}
          </div>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<style lang="scss" scoped>
  @import './payment-table.scss';
</style>

<script>

  import { set, get, map, find, startCase, cloneDeep, reduce, isEmpty } from 'lodash'
  import moment from 'moment'
  import { API } from '@/utils/api'
  import { userSelectColumnsMixin } from './userSelectColumnsMixin'
  import selectFilterValueMixin from './selectFilterValueMixin'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'
  import DatePicker from '@/components/core/DatePicker/DatePicker.vue'

  export default {
    components: { SelectProject, DatePicker },

    props: [ 'title' ],
    mixins: [ userSelectColumnsMixin, selectFilterValueMixin ],
    data: () => ({
      expanded: [],
      columnMenu: false,
      entities: false,
      from: moment().subtract(7, 'days').format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD'),
      headers: [
        { text: 'Created', value: 'created', 'class': 'nowrap' },
        { text: 'LastUpdate', value: 'updated', 'class': 'nowrap' },
        { text: 'AccountID', value: 'account_id', sortable: false, 'class': 'nowrap' },
        { text: 'Login', value: 'login', sortable: false, 'class': 'nowrap', defaultHide: true },
        { text: 'Amount', value: 'amount', 'class': 'nowrap' },
        { text: 'Currency', value: 'currency', 'class': 'nowrap' },
        { text: 'In EUR', value: 'amount_eur', 'class': 'nowrap' },
        { text: 'Paymethod', value: 'paymethod', 'class': 'nowrap' },
        { text: 'Paysystem', value: 'paysystem', 'class': 'nowrap' },
        { text: 'Status', value: 'status', 'class': 'nowrap' },
        { text: 'By', value: 'operator', 'class': 'nowrap', sortable: false },
        { text: 'Account', value: 'account', 'class': 'nowrap' },
        { text: 'Description', align: 'left', sortable: false, value: 'comment', 'class': 'nowrap' },
        { text: '', value: 'data-table-expand', 'class': 'nowrap' },
      ],
      filters: {
        status: { data: [], type: 'select' },
        paymethod: { data: [], type: 'select' },
        paysystem: { data: [], type: 'select' },
        account: { data: [], type: 'account' },
        account_id: { data: [], type: 'text' },
      },
      statuses: [ 'pending', 'complete', 'cancel', 'decline', 'error', 'processing', ],
      project: null,
      loading: false,
      items: [],
      itemsInit: [],
      options: {},
      total: 0,
    }),

    mounted () {
      this.loadEntities()
    },

    watch: {
      project () {
        if (this.options.page != 1) {
          this.options.page = 1
        } else {
          this.search()
        }
      },
      options: {
        handler () {
          this.search()
        },
      }
    },

    methods: {

      startCase: (k) => startCase(k),

      loadEntities () {
        return API.call('/users/entity_list.json').then(resp => {
          this.entities = resp.data
          return resp.data
        }).catch(e => {
        })
      },

      updateTransaction: async function (item) {

        if (!this.$store.state.auth.checkAccess({ key: 'payment_handler_update', value: true })) {
          return
        }

        let buttons = [
          { text: 'Confirm', value: true, class: 'primary darken-1' },
          { text: 'Cancel', value: false, class: 'grey' },
        ]

        if (get(item, 'status') != get(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), 'status') && get(item, 'status') === 'complete') {
          buttons = [
            { text: 'Change only status', value: true, class: 'primary darken-1' },
            { text: 'Complete deposit', value: 'increase_balance', class: 'primary darken-1' },
            { text: 'Cancel', value: false, class: 'grey' },
          ]
        }

        let confirmRes = await this.$root.$confirm('Confirm', 'Do you want save changes?', { width: 515, buttons })

        if (confirmRes) {

          API.call('/$v/payment_handler/update.json', {
            account_transaction_id: item.account_transaction_id,
            status: get(item, 'status') != get(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), 'status') ? item.status : undefined,
            comment: item.comment,
            increase_balance: confirmRes == 'increase_balance'
          }, null, this.project || this.project.value).then(resp => {

            if (resp.data.status == item.status || resp.data.comment == item.comment) {
              if (resp.data.comment == item.comment) {
                set(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), 'comment', item.comment)
              }
              if (resp.data.status == item.status) {
                set(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), 'status', item.status)
              }
            } else {

              this.$nextTick(function () {
                if (resp.data['comment']) {
                  set(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), 'comment', resp.data['comment'])
                  item.comment = resp.data.comment
                }
                if (resp.data['status']) {
                  set(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), 'status', resp.data['status'])
                  item.status = resp.data.status
                }
              })

            }

            this.$notification.show = true
            this.$notification.message = 'Transaction updated'
            this.$notification.type = 'success'

            return resp.data
          }).catch(e => {

            this.search()
          })
        } else {
          this.$nextTick(function () {
            item.comment = get(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), 'comment')
            item.external_account_transaction_id = get(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), 'external_transaction_id')
          })
        }
      },

      search: function () {
        this.loading = true

        API.call('/$v/payment_handler/list.json', {
          from: this.from,
          to: this.to,
          type: 'deposit',
          options: this.options,
          filters: reduce(this.filters, (r, f, k) => {
            if (!isEmpty(f.data)) {
              r[k] = f.data
            }
            return r
          }, {}),
          limit: 50
        }, null, this.project).then(resp => {

          this.total = resp.total
          this.items = cloneDeep(resp.data)
          this.itemsInit = cloneDeep(resp.data)

          return resp.data
        })
          .then(() => this.loadTableColums('deposit'))
          .catch(e => {
          })
          .finally(() => {
            this.loading = false
          })

      },

      changeSort (column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },
      columnValueList (val) {
        if (val == 'status') {
          return [ 'pending', 'complete', 'cancel', 'decline', 'error', 'processing', ]
        }
        return this.items.map(d => d[val])
      },
    },
  }
</script>
